import { useSignal } from "@preact/signals-react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { layout as layoutRoom } from "./ModelRoom";
import CardsRooms from "./CardsRooms";
import proxy from "api/proxy";

// const styleLocation =
//   "flex space-x-3 mx-1 cursor-pointer px-4 py-2 rounded-md text-center font-light text-sm shadow-md transition-all select-none";

async function getOperationCenter() {
  const session = proxy.getSession();
  let ocId = null;
  if (session.shop_) {
    const { data: shopData } = await proxy.search(
      "sale.shop",
      [["id", "=", session.shop_.id]],
      ["operation_center"],
    );
  }

  if (!ocId) {
    const { data: ocData } = await proxy.search(
      "res.user",
      ["id", "=", session.user],
      ["operation_center"],
    );

    ocId = ocData?.[0]?.operation_center ?? null;
  }
  return ocId;
}

async function getHousekeepingData(softDomain) {
  const oc = await getOperationCenter();
  if (!oc) return null;

  const res = await proxy.methodCall({
    model: "hotel.room",
    method: "get_housekeeping_board",
    args: [{ oc }],
  });
  const { data } = res;
  if (!data?.records) return data;
  const { data: activeRooms } = await proxy.search("hotel.room", softDomain, [
    "id",
  ]);
  const activeIds = new Set(activeRooms.map((room) => room.id));
  data.records = data.records.filter((record) => activeIds.has(record.room_id));

  return res?.data;
}

function Housekeeping() {
  const queryClient = useQueryClient();
  const locationSelected = useSignal(null);
  const layout = layoutRoom();

  const { data: locations = [], isLoading } = useQuery({
    queryKey: ["housekeepingLocations"],
    queryFn: async () => {
      const { data } = await proxy.search("hotel.location", [], ["id", "name"]);
      return data ?? [];
    },
  });

  // FIXME
  function handleFilter(locId) {
    locationSelected.value = locationSelected.value === locId ? null : locId;
  }

  const { data } = useQuery({
    queryKey: ["get_housekeeping_data"],
    queryFn: () => getHousekeepingData(layout.softDomain),
  });

  // effect(() => {
  //   const selectedId = locationSelected.value;
  //   layout.domain = selectedId ? [["location_id", "=", selectedId]] : [];
  // });

  async function onRefresh() {
    await queryClient.refetchQueries({
      queryKey: ["get_housekeeping_data"],
    });
  }

  console.log("data", data?.records);

  return (
    <div className="w-full flex flex-col h-fit">
      {data?.records && (
        <CardsRooms
          layout={layout}
          records={data?.records}
          style="max-md:w-screen max-md:overflow-x-hidden"
          onRefresh={onRefresh}
        />
      )}
    </div>
  );
}

// <div className="flex max-md:flex-col mb-4 mt-2 max-md:space-y-2">
//   <span className="font-medium text-neutral-500 my-auto text-xl md:mx-4 uppercase hidden lg:block">
//     <FM id="hotel.room.locations" />
//   </span>
//   <div className="flex max-md:space-x-3 md:w-2/3 flex-wrap gap-2">
//     {!isLoading &&
//       locations.map((item) => (
//         <div
//           key={item.id}
//           className={cn(
//             styleLocation,
//             locationSelected.value === item.id
//               ? "bg-lime-200"
//               : "bg-stone-200",
//           )}
//           onClick={() => handleFilter(item.id)}
//         >
//           {item.name}
//         </div>
//       ))}
//   </div>
// </div>

export default Housekeeping;
